export const CONTACT = {
  name: "Healthy Home Bakery",
  tagline: "Sugar-Free · Diabetic-Friendly",
  address: "Tampa, FL 33603",
  phone: "(813) 498-2529",
  email: "healthyhomebakerysf@gmail.com",
  hours: [
    { day: "Mon – Fri", time: "9:00 AM – 6:00 PM" },
    { day: "Saturday", time: "10:00 AM – 4:00 PM" },
    { day: "Sunday", time: "By appointment" },
  ],
  socials: [
    { label: "Instagram", href: "#" },
    { label: "Facebook", href: "#" },
    { label: "TikTok", href: "#" },
  ],
};

export const TESTIMONIALS = [
  {
    name: "Marisol Rivera",
    tag: "Type 2 Diabetic",
    rating: 5,
    quote:
      "I wore my glucose monitor while eating the chocolate chip cookies — no spike at all. They taste just like real sugar. I finally have dessert again.",
    avatar: "https://images.unsplash.com/photo-1662850886700-4ec19bd30d11?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    name: "Danielle Chen",
    tag: "Keto for 3 years",
    rating: 5,
    quote:
      "The almond flour cookies are 3g net carbs and genuinely the best keto treat I've had. Zero chemical aftertaste — you'd never know they're sugar-free.",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    name: "Priya Anand",
    tag: "Fitness Coach",
    rating: 5,
    quote:
      "I order the custom celebration cakes for every client milestone. Beautiful, wholesome, and they fit right into a macro plan. My clients are obsessed.",
    avatar: "https://images.unsplash.com/photo-1484863137850-59afcfe05386?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
];

export const FAQS = [
  {
    q: "How much notice do you need for large orders?",
    a: "We require a minimum of 5 days notice for all large orders, so please reach out early to secure your date.",
  },
  {
    q: "Do you offer delivery or is it pickup only?",
    a: "Local pickup is available from our home studio in Tampa, FL. We also offer next-day shipping via FedEx / UPS mail service so you can enjoy our treats wherever you are. Shipping is arranged after your order is confirmed.",
  },
  {
    q: "What sweeteners do you use?",
    a: "We use only natural, blood-sugar-friendly sweeteners: Maple Syrup, Honey, and Bananas. These provide real sweetness with a negligible glycemic impact — no cane sugar, corn syrup, or artificial sweeteners ever.",
  },
  {
    q: "Are your treats safe for diabetics?",
    a: "Yes. Every recipe is formulated to minimize blood glucose impact using zero added sugar and low-net-carb flours. Many of our customers monitor their glucose and report no spikes. As always, consult your doctor for your specific needs.",
  },
  {
    q: "How should I store my baked goods?",
    a: "Breads and cookies keep 3–4 days at room temperature in an airtight container, or up to 3 months frozen. Custom cakes with fresh frosting should be refrigerated and enjoyed within 4 days.",
  },
  {
    q: "How do large orders deposits work?",
    a: "A deposit reserves your date and covers ingredient sourcing. You can pay securely via PayPal or Zelle. The remaining balance is due at pickup or delivery.",
  },
];
